import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useProject } from "../project";
import { apiClient } from "../service/tekkr-service";
import { ProjectChatUiContext } from "tekkr-common/dist/model/project/chat";

interface Data {
    chatId: string;
}

interface Options {
    onSuccess?: (data: Data) => void;
}

export function useCreateChatMutation(uiContext: ProjectChatUiContext, options?: Options) {
    const { project } = useProject();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (): Promise<Data> => {
            const res = await apiClient.createProjectChat({
                params: {
                    projectId: project.id,
                },
                body: {
                    uiContext,
                },
            });
            if (res.status !== 200) {
                throw new Error("Error creating chat");
            }
            return {
                chatId: res.body.chatId,
            };
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["chats", project.id] });
            options?.onSuccess?.(data);
        },
    });
}
